// extracted by mini-css-extract-plugin
export default {"container":"FO-z","topReviewHeading":"GO-z","criticalReview":"HO-z","favorableReview":"IO-z","vsSeparator":"JO-z"};